<div class="modal-body">
  <lh-payment-options
    [(ngModel)]="paymentMethod"
    [booking]="booking"
    [paymentMethods]="paymentMethods"
    [isPaymentDue]="isPaymentDue"
  ></lh-payment-options>
</div>

<!-- <div class="modal-footer">
  <button id="closePaymentOptions" class="btn btn-primary" (click)="close()" [disabled]="!booking.paymentMethodId">{{ 'DONE' | translate }}</button>
</div> -->
